export default __webpack_public_path__ + "static/media/er.04bcc2d3.svg";